/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, Feb 2021
 * @flow
 */

import React from 'react';
import PropTypes from 'prop-types';
import styles from './PopupHeader.module.css';

const PopupHeader = (props) => {
  const {
    title,
    onClose,
    containerStyle,
    titleStyle,
    closeIconStyle,
  } = props;

  return (
    <div className={[styles.heading, containerStyle].join(' ')}>
      <h3 className={titleStyle}>{title}</h3>
      <h3 className={[styles.close, closeIconStyle].join(' ')} onClick={onClose}>X</h3>
    </div>
  );
};

export default PopupHeader;

PopupHeader.propTypes = {
  title: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  containerStyle: PropTypes.any,
  titleStyle: PropTypes.any,
  closeIconStyle: PropTypes.any,
};

PopupHeader.defaultProps = {
  title: '',
  onClose: () => { },
  containerStyle: {},
  titleStyle: {},
  closeIconStyle: {},
};
